import Mutations from '../../odata/mutations';

export default { ...new Mutations('gallery'), ...new Mutations('galleries'), ...new Mutations('images') };
